import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../providers/AuthProvider'
import { supabase } from '../../lib/supabaseClient'

interface PlanRow {
  id: string
  user_id: string
  advisor_id: string | null
  plan: any
  created_at: string
  updated_at: string
}

export function AdvisorHome() {
  const { session } = useAuth()
  const [plans, setPlans] = useState<PlanRow[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let mounted = true
    const load = async () => {
      if (!session) return
      setLoading(true)
      const { data } = await supabase
        .from('plans')
        .select('id, user_id, advisor_id, plan, created_at, updated_at')
        .eq('advisor_id', session.user.id)
        .order('updated_at', { ascending: false })
      if (!mounted) return
      setPlans((data as any[]) ?? [])
      setLoading(false)
    }
    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session?.user.id])

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-2xl font-bold mb-6">Advisor Dashboard</h1>
        {loading ? (
          <div className="text-gray-600">Loading...</div>
        ) : plans.length === 0 ? (
          <div className="text-gray-600">No client plans yet.</div>
        ) : (
          <div className="grid md:grid-cols-2 gap-6">
            {plans.map((p) => (
              <div key={p.id} className="card">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="font-semibold">{p.plan?.clientName ?? `Plan ${p.id.slice(0, 8)}`}</h3>
                    <p className="text-sm text-gray-600">{p.plan?.email ?? ''}</p>
                    <p className="text-xs text-gray-500 mt-1">Updated {new Date(p.updated_at).toLocaleString()}</p>
                  </div>
                  <Link className="btn-secondary" to={`/dashboard/${p.id}`}>Open</Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}


